//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import axios from 'axios';
import ECharts from 'vue-echarts';
import portal from '~/net/portal';
import config from '~/config';
import { isNumber } from '~/constant/validform';
import { searchCodes } from '~/constant/SearchCodes';
import { cooperationModeNew, kfPayMode } from '~/constant/types';
import ChatBox from '~/components/ChatBox';
export default {
  name: 'Good',
  components: {
    'v-chart': ECharts,
    ChatBox,
  },
  head() {
    return {
      title: this.good.name + '-江苏省技术产权交易市场平台',
      meta: [
        { hid: 'keywords', name: 'keywords', content: this.good.name },
        { hid: 'description', name: 'description', content: this.good.summary },
      ],
    };
  },
  data() {
    return {
      typeChatBox: null,
      questionsArray: [
        '该成果有哪些相似的成果？',
        '该成果可能有哪些需求方？',
        '该成果可能的应用领域？',
      ],
      showChatBox: false, // 控制聊天框显示/隐藏
      routes: [],
      pgInfo: {},
      agentShow: false,
      spinShow: false,
      showZGData: false,
      rateLevel: 'all',
      errorImg: 'this.src="' + require(`~/assets/images/default.png`) + '"',
      rateList: [],
      wechatUrl: '',
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 10,
        watchOverflow: true,
        loop: false,
        slidesPerGroup: 2,
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev',
        },
      },
      patentValueEstimateShow: false,
      codes: searchCodes,
      agentSuccess: false,
      onlineAssessVisible: false,
      collectionVisible: false,
      isVisble: false,
      portocol: {
        content: '',
        createTime: '',
        version: '',
      },
      good: {},
      phoneVisble: false,
      loginVisible: false,
      dialogVisible: false,
      refresh: false,
      businessBrowserUrl: config.businessBrowserUrl,
      buyForm: {
        title: '',
        agreeProtocal: false,
        price: 0,
      },
      rules: {
        price: isNumber('价格必须输入数字'),
      },
      maxPage: 3,
      currentPage: 1,
      assess: {},
      contactPhoneVisible: false,
      page: {
        page: 1,
        rows: 10,
      },
      total: 0,
      recommandServices: [],
      // recommandTechs: [],
      wenjuan: '',
      wenjuanResult: {
        option: '',
        optionOneNum: 0,
        optionTwoNum: 0,
        optionThreeNum: 0,
      },
      radaroption: {},
      radaroptionNew: {}, // 专利价值评估雷达图
      wenjuanExpand: true,
      patentEvaluation: {},
      techScore: 0,
      lawScore: 0,
      economyScore: 0,
      highValueList: [],
      highValueCount: 0,
      showPatentBtn: false,
      radaroptionold: {},
      tipStr: '',
      topImage: {},
    };
  },
  validate({ query }) {
    return !!query.id;
  },
  watch: {
    user(val) {
      if (!val) {
        portal
          .getGoodsInfo({
            query: {
              id: this.$route.query.id,
              isPortal: true,
            },
          })
          .then((res) => {
            this.good = res.data;
          });
      }
    },
    $route(to, from) {
      if (to.fullPath !== from.fullPath) {
        this.$nextTick(() => {
          // 不加this.$nextTick时，路由跳转后还是上一次的数据，所以需要加上
          this.getGoodDetailInfo(); // 需要执行的方法
        });
      }
    },
    wenjuanExpand(value) {
      !value && this.$refs.ChatBoxRef.clearAnswers();
    },
  },
  async asyncData({ query, error, req }) {
    const [resp1, resp2] = await Promise.all([
      portal.judgeCollected({
        query: {
          id: query.id,
          type: '00',
        },
        client: req,
      }),
      portal.getAchievementById({
        query: {
          id: query.id,
          number: 12,
        },
        client: req,
      }),
    ]);
    const data2 = resp1.data;

    return {
      collectionStatus: data2 == '01', // 01 未收藏 00 已收藏
      recommandGoods: resp2.data || [],
      // recommandGoods: [],
      baseURl: typeof window === 'undefined' ? config.PortalBaseURL : config.PortalBrowserBaseURL,
    };
  },
  mounted() {
    this.getGoodDetailInfo();
  },
  watchQuery: ['id'],
  computed: {
    difyKeyword() {
      return this.good?.difyKeyword?.replace(/[,，]/g, ' ') ?? '';
    },
    ...mapState(['user', 'identities']),
    // routes() {
    //     if (this.good.confThemeActivityId == '202410602943614795' && localStorage.getItem('navigationType') == 'lasa') {
    //         return [{ name: '拉萨首页', path: '/lasaDemand/home' }, { name: '商品', path: '/lasaDemand/goodsList' }, { name: this.good.name }]
    //     }
    //     return [{ name: '首页', path: '/' }, { name: this.getGoodType() }, { name: this.good.name }]
    // },
    getGoodImages() {
      if (this.good.hasOwnProperty('goodsFileDtos')) {
        const list = this.good.goodsFileDtos
          .filter((_) => {
            return _.fileType == 3;
          })
          .map((_, index) => {
            return {
              id: index,
              src: _.fileUrl,
            };
          });
        return list;
      } else {
        return [];
      }
    },
    canProxy() {
      return (
        this.good.owner === '1' &&
        this.good.type != '03' &&
        this.identities?.some((_) => _.type == '01' && _.isBind != 2)
      );
      // return this.good.owner === '1' && this.good.type != '03'  && (this.identities?.some(_ => _.type == '01' && _.isBind != 2) ||false)
    },
    isOneself() {
      if (this.user != null && this.good.userId != null) {
        return this.user.id != this.good.userId;
      } else {
        return true;
      }
    },
    currentPageGoods() {
      return this.recommandGoods.slice((this.currentPage - 1) * 4, this.currentPage * 4);
      // return this.recommandTechs.slice((this.currentPage - 1) * 4, this.currentPage * 4)
    },

    location() {
      if (this.good.goodServiceDetail != undefined)
        return [
          this.good.goodServiceDetail.province,
          this.good.goodServiceDetail.city,
          this.good.goodServiceDetail.area,
        ];
    },
    flow() {
      return this.good && this.good.goodServiceDetail && this.good.goodServiceDetail.flow;
    },
    safe() {
      return this.good && this.good.goodServiceDetail && this.good.goodServiceDetail.safe;
    },
    listlimit() {
      // if (this.good.listing) {
      //     let date1 = new Date(this.good.startAt)
      //     let date2 = new Date()
      //     date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate())
      //     date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())
      //     const diff = date2.getTime() - date1.getTime()
      //     const diffDate = diff / (24 * 60 * 60 * 1000)
      //     return diffDate < 20
      // } else {
      //     return false
      // }
      return false;
    },
    wenjuanTotal() {
      return (
        this.wenjuanResult.optionOneNum +
        this.wenjuanResult.optionTwoNum +
        this.wenjuanResult.optionThreeNum
      );
    },
    bidDetailLink() {
      return 'http://bid.jstec.com.cn/tradingHall/redirect?goodsId=' + this.good.id;
    },
    miniCode() {
      return (
        this.baseURl +
        `/crowdsourceDemand/getMiniProgramCode?page=pages%2Fgoods%2Findex&scene=${this.good.id}&source=mall`
      );
    },
    systemTags() {
      if (this.good.systemTag) {
        return this.good.systemTag.split(',');
      } else {
        return [];
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.user == null && to.path == '/report') {
      this.loginVisible = true;
      next(false);
    } else if (!!this.user && to.path == '/report') {
      portal
        .queryReport({
          query: {
            goodsId: this.good.id,
          },
        })
        .then((res) => {
          if (res.code === '0000') {
            next();
          } else {
            next(false);
          }
        });
    } else {
      next();
    }
  },
  methods: {
    closeChatBox() {
      this.showChatBox = false;
      this.$refs.ChatBoxRef.clearAnswers();
    },
    askQuestion(value, type) {
      this.typeChatBox = type === 2 ? null : type;
      this.showChatBox = true; // 点击问题时也显示聊天框
      if (this.wenjuanExpand) {
        this.$nextTick(() => {
          this.$refs.ChatBoxRef.generateAnswer(value);
        });
      }
    },
    getRoutes() {
      // this.good.confThemeActivityId == '202410602943614795' &&
      if (localStorage.getItem('navigationType') == 'lasa') {
        this.routes = [
          { name: '拉萨首页', path: '/lasaDemand/home' },
          { name: '商品', path: '/lasaDemand/goodsList' },
          { name: this.good.name },
        ];
        return;
      }
      // this.good.confThemeActivityId == '202428303021097797' &&
      if (localStorage.getItem('navigationType') == 'gaoxiao') {
        this.routes = [
          { name: '高校首页', path: '/collegeHome' },
          { name: '科技成果', path: '/technologicalAchievement' },
          { name: this.good.name },
        ];
        return;
      }
      this.routes = [
        { name: '首页', path: '/' },
        { name: this.getGoodType() },
        { name: this.good.name },
      ];
    },
    async getGoodDetailInfo() {
      const { code, data } = await portal.getGoodsInfo({
        query: {
          id: this.$route.query.id,
          isPortal: true,
        },
      });
      if (code == '0000') {
        this.good = data;
        this.getRoutes();
        this.topImage = this.good.hasOwnProperty('goodsFileDtos') ? this.good.goodsFileDtos[0] : {};
        portal
          .getShopDetailsById({
            query: { shopId: this.good.shopId },
          })
          .then(({ code, data }) => {
            if (code == '0000') {
              this.wechatUrl = data.wechatUrl;
            }
          });
        this.getRatesAsync();
        if (this.good.type == '01' || this.good.type == '02') {
          portal.getRecommandService().then(({ code, data }) => {
            if (code == '0000') {
              this.recommandServices = data.filter(Boolean);
            }
          });
        }
        this.getGoodsInvestigationByIdAsync();
        this.getGoodsInvestigationByIdAsync();
        if (this.good.valueA != null && this.good.valueA != undefined) {
          this.getGoodsScores();
        }
        this.isShowPatentEvaluation();
        this.tipStr = this.getHightTechList();
      }
    },
    showPhone() {
      if (!this.user) {
        this.$router.push({
          path: '/login',
          query: {
            url: '/goods?id=' + this.good.id,
          },
        });
      }
    },
    async isShowPatentEvaluation() {
      const { data, code } = await portal.selectFunctionSwitch({
        query: {
          sceneType: '01',
        },
      });
      if (code == '0000') {
        this.showPatentBtn = data == '01';
      }
    },
    async getSelectPatentEvaluation() {
      const { code, data } = await portal.selectPatentEvaluation({
        query: {
          ano: this.good.patentApplyNo, // this.good.patentApplyNo 'CN202311456551.4'  'CN202211283042.1'
        },
      });
      if (code == '0000') {
        // this.patentValueEstimateShow = true
        this.showZGData = true;
      } else {
        this.showZGData = false;
        if (this.pgInfo.AllScore != '0') {
          this.drawOriginScore();
        } else {
          this.$Message.warning('未查询到专利价值评估数据');
          this.onlineAssessVisible = false;
        }
        return;
      }
      if (data.dataList) {
        JSON.parse(data.dataList).map((val) => {
          if (val.title == '技术维度') {
            this.techScore = val.segmented;
          } else if (val.title == '法律维度') {
            this.lawScore = val.segmented;
          } else {
            this.economyScore = val.segmented;
          }
        });
      }
      this.highValueList = [];
      if (data.highValueList) {
        this.highValueList.push(
          data.highValueList.includes('战略性新兴产业') ? 'icon05_highlight.png' : 'icon05.png'
        );
        this.highValueList.push(
          data.highValueList.includes('维持超过10年') ? 'icon04_highlight.png' : 'icon04.png'
        );
        this.highValueList.push(
          data.highValueList.includes('有海外同族专利') ? 'icon03_highlight.png' : 'icon03.png'
        );
        this.highValueList.push(
          data.highValueList.includes('专利质押') ? 'icon02_highlight.png' : 'icon02.png'
        );
        this.highValueList.push(
          data.highValueList.includes('中国专利奖') ? 'icon01_highlight.png' : 'icon01.png'
        );
        this.highValueCount = data.highValueList.length;
      } else {
        this.highValueList.push('icon05.png');
        this.highValueList.push('icon04.png');
        this.highValueList.push('icon03.png');
        this.highValueList.push('icon02.png');
        this.highValueList.push('icon01.png');
        this.highValueCount = 0;
      }
      this.patentEvaluation = data;
      if (this.pgInfo.AllScore == '0') {
        this.onlineAssessVisible = false;
        this.patentValueEstimateShow = true;
        this.getPatentEvaluation();
      } else {
        this.getPatentEvaluation();
        this.drawOriginScore();
      }
    },
    // 专利价值评估雷达图
    getPatentEvaluation() {
      this.radaroptionNew = {
        legend: {},
        radar: [
          {
            indicator: [
              { text: `经济维度：${this.economyScore}分`, max: 50 },
              { text: `法律维度：${this.lawScore}分`, max: 50 },
              { text: `技术维度：${this.techScore}分`, max: 50 },
            ],
            startAngle: 90,
            splitNumber: 3,
            name: {
              formatter: '{value}',
              color: '#2A7AFF',
            },
            splitArea: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            type: 'radar',
            itemStyle: {
              color: '#88D3FF',
            },
            label: {
              show: false,
              fontSize: 16,
              formatter(params) {
                return params.value;
              },
            },
            areaStyle: {
              color: 'rgba(197,231,255,0.8)',
            },
            data: [
              {
                value: [this.economyScore, this.lawScore, this.techScore],
              },
            ],
          },
        ],
      };
    },
    async getGoodsInvestigationByIdAsync() {
      const { code, data } = await this.$api.getGoodsInvestigationById({
        id: this.good.id,
      });
      if (code == '0000') {
        this.wenjuanResult = {
          optionOneNum: data?.optionOneNum || 0,
          optionTwoNum: data?.optionTwoNum || 0,
          optionThreeNum: data?.optionThreeNum || 0,
          option: data?.option || '',
        };
        this.wenjuan = this.wenjuanResult.option;
      }
    },
    getGoodsScores() {
      // 四维雷达图
      this.radaroption = {
        color: ['#f90909', '#FFE434', '#56A3F1', '#FF917C'],
        // title: {
        //     text: '四维价值评估'
        // },
        legend: {},
        radar: [
          {
            indicator: [
              { text: '科学价值', max: 150 },
              { text: '技术价值', max: 150 },
              { text: '社会价值', max: 150 },
              { text: '经济价值', max: 150 },
            ],
            center: ['25%', '50%'],
            radius: 60,
            startAngle: 90,
            splitNumber: 4,
            shape: 'circle',
            name: {
              formatter: '【{value}】',
              color: '#2A7AFF',
            },
            splitArea: {
              areaStyle: {
                color: ['#77EADF', '#26C3BE', '#64AFE9', '#428BD4'],
                shadowColor: 'rgba(0, 0, 0, 0.2)',
                shadowBlur: 10,
              },
            },
          },
        ],
        series: [
          {
            type: 'radar',
            emphasis: {
              lineStyle: {
                width: 4,
              },
            },
            data: [
              {
                value: [this.good.valueA, this.good.valueB, this.good.valueC, this.good.valueD],
                label: {
                  show: true,
                  formatter(params) {
                    return params.value;
                  },
                },
              },
            ],
          },
        ],
      };
    },

    async wenjuanSubmitAsync() {
      if (this.user == null) {
        this.loginVisible = true;
      } else {
        if (this.wenjuanResult.option != '') {
          this.$Message.warning('您已提交过,不可重复提交');
          return;
        }

        if (this.wenjuan == '') {
          this.$Message.warning('您还没有选择意向调查,不可提交');
          return;
        }

        const { code, data } = await this.$api.addGoodsInvestigation({
          goodsId: this.good.id,
          option: this.wenjuan,
        });
        if (code == '0000') {
          this.$Message.success('提交成功');
          this.getGoodsInvestigationByIdAsync();
        } else {
          this.$Message.error(message);
        }
      }
    },
    handleConsultShopClick(id) {
      this.$store.dispatch('consultCourierShop', id);
    },
    handleShopMainClick(id) {
      this.$router.push(`/shop?id=${id}`);
    },
    operateClick() {
      location.href = this.businessBrowserUrl + '/realname';
    },
    collection() {
      if (this.user == null) {
        this.loginVisible = true;
      } else {
        this.collectionVisible = true;
      }
    },
    // 收藏  传收藏id
    collectionConfirm() {
      portal
        .setCollectStatus({
          query: {
            id: this.good.id,
            type: '00',
            status: this.collectionStatus ? '00' : '01',
          },
        })
        .then((res) => {
          const { code, message } = res;
          if (code === '0000') {
            this.collectionVisible = false;
            this.collectionStatus = !this.collectionStatus;
            if (!this.collectionStatus) this.$Message.success('收藏成功');
            else this.$Message.success('已取消收藏');
          }
        });
    },
    selectedItemChanged(item) {
      this.topImage = {
        fileUrl: item.src,
      };
    },
    showOnlineAssess() {
      if (this.user == null) {
        this.loginVisible = true;
      } else this.xianshi();
    },
    xianshi() {
      const that = this;
      this.onlineAssessVisible = true;
      let jname = that.good.patentApplyNo; // 'CN202211283042.1' // that.good.patentApplyNo
      const number2 = jname.substring(0, 2);
      if (number2 == 'ZL') {
        jname = jname.replace('ZL', 'CN');
      } else if (number2 * 1 == number2) {
        jname = 'CN' + jname;
      }
      const reaFormData = new FormData();
      reaFormData.append('parameter', 'getPatentValuebyjscq');
      reaFormData.append('appNum', jname);
      that.spinShow = true;
      portal
        .getPatentValue({
          query: {
            appNum: jname,
          },
        })
        .then(function(res) {
          that.spinShow = false;
          if (res.data.code == '0000') {
            that.pgInfo = res.data;
            that.pgInfo.AllScore = res.data.AllScore.toFixed(2);
            that.drawOriginScore();
            that.getSelectPatentEvaluation();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
      // axios({
      //   method: 'post',
      //   url: 'https://www.jssic.cn/tcpt/publicPC/UPCforWard',
      //   data: reaFormData,
      // })
      //   .then(function(res) {
      //     that.spinShow = false;
      //     if (res.data.code == '1000') {
      //       that.pgInfo = res.data;
      //       that.pgInfo.AllScore = res.data.AllScore.toFixed(2);
      //       that.drawOriginScore();
      //       that.getSelectPatentEvaluation();
      //     }
      //   })
      //   .catch(function(error) {
      //     console.log(error);
      //   });
    },

    drawOriginScore() {
      const dataArr = [
        this.pgInfo.DaiLiJiGou,
        this.pgInfo.JiShuFanWei,
        this.pgInfo.QuanLiYaoQiu,
        this.pgInfo.BuJuGuoJiaShuLiang,
        this.pgInfo.ChuanXinNanDu,
      ];
      this.radaroptionold = {
        legend: {},
        radar: [
          {
            indicator: [
              { text: `代理机构得分：${dataArr[0]}分`, max: 25 },
              { text: `技术范围得分：${dataArr[1]}分`, max: 25 },
              { text: `权利要求得分：${dataArr[2]}分`, max: 25 },
              { text: `布局国家得分：${dataArr[3]}分`, max: 25 },
              { text: `创新难度得分：${dataArr[4]}分`, max: 25 },
            ],
            startAngle: 90,
            splitNumber: 5,
            name: {
              formatter: '{value}',
              color: '#2A7AFF',
            },
            splitArea: {
              show: false,
            },
          },
        ],
        series: [
          {
            type: 'radar',
            itemStyle: {
              color: '#88D3FF',
            },
            label: {
              show: false,
              fontSize: 16,
              // formatter(params) {
              //     return params.value
              // }
            },
            areaStyle: {
              color: 'rgba(197,231,255,0.8)',
            },
            data: [
              {
                value: dataArr,
                // value: [80, 91, 97, 85, 82]
              },
            ],
          },
        ],
      };
    },
    showDetail() {
      this.onlineAssessVisible = false;
      this.patentValueEstimateShow = true;
    },

    showBuyDialog() {
      this.$store.dispatch('CheckRealName').then(
        (res) => {
          this.dialogVisible = true;
          if (this.good.payMode == 0 && !this.listlimit) {
            this.buyForm.title = '立即购买';
          } else {
            this.buyForm.title = '意向购买';
          }
        },
        (err) => {
          if (err == null) {
            this.$router.push('/login');
          } else {
            this.$store.commit('SET_REALNAME', true);
          }
        }
      );
    },
    showProtocal() {
      this.getProtocolAsync();
    },
    async getRatesAsync() {
      const query = {
        ...{
          goodsId: this.good.id,
          level: this.rateLevel === 'all' ? '' : this.rateLevel,
        },
        ...this.page,
      };
      const { code, data } = await portal.getGoodsRatesById({
        query,
      });
      if (code == '0000') {
        const { total, rows } = data;
        this.rateList = rows || [];
        this.total = total;
      }
    },
    change(page) {
      this.page.page = page;
      this.getRatesAsync();
    },
    buy() {
      let params = {};
      if (this.good.payMode == 0) {
        if (!this.buyForm.agreeProtocal) {
          this.$Message.warning('同意平台《交易规则》条款方可购买');
          return;
        }
        params = {
          status: '04',
          goodId: this.good.id,
        };
        this.handlePurchaseAsync(params);
      } else {
        if (this.buyForm.price < 0) {
          this.$Message.warning('金额不能为负数');
          return;
        }
        this.$refs.buyForm.validate((valid) => {
          if (valid) {
            if (!this.buyForm.agreeProtocal) {
              this.$Message.warning('同意平台《交易规则》条款方可购买');
              return;
            }
            params = {
              status: '01',
              goodId: this.good.id,
              price: this.buyForm.price,
            };
            this.handlePurchaseAsync(params);
          }
        });
      }
    },
    getGoodType() {
      if (this.good.type == '01') return '专利';
      else if (this.good.type == '02') return '技术成果';
      else return '服务';
    },
    getPayMode() {
      if (this.good.payMode == 0) return '一口价';
      else if (this.good.payMode == 1) return '意向购买';
      else if (this.good.payMode == 3) return '在线竞价';
      else return '';
    },
    getPatentLawStatus() {
      let status = '';
      switch (this.good.patentLawStatus) {
        case '1':
          status = '审中';
          break;
        case '2':
          status = '有权';
          break;
        case '3':
          status = '无权';
          break;
        default:
          break;
      }
      return status;
    },
    filterChildType(childType) {
      if (!!childType && childType.startsWith('01')) {
        return this.codes[1].childs.find((_) => _.code == childType).name;
      } else return '';
    },
    getPatentStatus() {
      let status = '';
      switch (this.good.patentStatus) {
        case '1':
          status = '申请中';
          break;
        case '2':
          status = '已公开';
          break;
        case '3':
          status = '已授权';
          break;
        default:
          break;
      }
      return status;
    },
    getHightTechList() {
      if (this.good.type === '01') {
        if (typeof this.good.goodsPatentHighTechDtos !== 'undefined')
          return this.good.goodsPatentHighTechDtos
            .map((_) => {
              return _.emergingName;
            })
            .join(' ');
      } else if (typeof this.good.goodsAchievementHighTechDtos !== 'undefined')
        return this.good.goodsAchievementHighTechDtos
          .map((_) => {
            return _.achievementEmergingName;
          })
          .join(' ');
    },
    getAchievementStage(index) {
      const map = [
        {
          label: '实验室',
          value: '1',
        },
        {
          label: '小试',
          value: '2',
        },
        {
          label: '中试',
          value: '3',
        },
        {
          label: '产业化',
          value: '4',
        },
        {
          label: '其他',
          value: '5',
        },
        {
          label: '已有样品样机',
          value: '6',
        },
      ];
      const result = map.find((el) => el.value == index);
      return result ? result.label : '';
    },
    getGoodsAchievementPatentNo() {
      if (this.good.hasOwnProperty('goodsAchievementPatentDtos')) {
        return this.good.goodsAchievementPatentDtos[0].achievementNo;
      } else return '';
    },
    getGoodsAchievementPatentType() {
      if (this.good.hasOwnProperty('goodsAchievementPatentDtos')) {
        let achievementType = '';
        switch (this.good.goodsAchievementPatentDtos[0].achievementType) {
          case '1':
            achievementType = '技术秘密';
            break;
          case '2':
            achievementType = '专利';
            break;
          case '3':
            achievementType = '计算机软件';
            break;
          case '4':
            achievementType = '植物新品种';
            break;
          case '5':
            achievementType = '集成电路布图设计';
            break;
          case '6':
            achievementType = '生物医药新品种';
            break;
          default:
            achievementType = '';
            break;
        }
        return achievementType;
      } else return '';
    },
    getTransactionMode() {
      let status = '';
      if (this.good.transactionMode == '02') {
        if (this.good.licenseType == '00') {
          status = '独占许可';
        } else if (this.good.licenseType == '01') {
          status = '普通许可';
        } else if (this.good.licenseType == '02') {
          status = '排他许可';
        } else {
          status = '开放许可';
        }
        // }
      } else {
        const temp = cooperationModeNew.find((_) => _.type == this.good.transactionMode);
        status = (temp && temp.text) || '';
      }

      return status;
    },

    getkfPayMode() {
      let status = '';
      const temp = kfPayMode.find((_) => _.type == this.good.gxType);
      status = (temp && temp.text) || '';
      return status;
    },
    getAttachments() {
      if (this.good.hasOwnProperty('goodsFileDtos')) {
        return this.good.goodsFileDtos.filter((_) => _.fileType == 1);
      } else {
        return [];
      }
    },
    more() {
      this.refresh = true;
      setTimeout(() => {
        this.refresh = false;
        if (this.currentPage + 1 > 3 || this.currentPage + 1 > this.recommandGoods.length / 4) {
          this.currentPage = 1;
        } else this.currentPage++;
      }, 500);
    },
    applyAgentAsync() {
      this.agentShow = true;
    },
    async agentOK() {
      const { code, data, message } = await portal.applyAgent({
        query: { goodsId: this.good.id },
      });
      if (code === '0000') {
        this.agentSuccess = true;
      }
      if (code === '131147') {
        this.$Message.warning('您必须要有一个自己店铺才能代理商品');
      }
    },
    async handlePurchaseAsync(params) {
      const { code } = await portal.handlePurchase({
        query: params,
      });
      if (code === '0000') {
        this.$Message.success('购买确认成功');
        this.dialogVisible = false;
      } else {
        this.$Message.error(message);
      }
    },
    async getProtocolAsync() {
      const resp = await portal.getProtocol({
        query: {
          type: '06',
        },
      });
      if (resp.code == '0000') {
        this.isVisble = true;
        this.portocol = resp.data;
      }
    },
    getGoodPatentApplicatDtosStr() {
      if (this.good.type == '02') {
        // 成果
        if (typeof this.good.goodsAchievementApplicantDtos !== 'undefined')
          return this.good.goodsAchievementApplicantDtos
            .map((_) => {
              return _.achievementName;
            })
            .join(' ');
      } else if (typeof this.good.goodsPatentApplicantDtos !== 'undefined') {
        // 专利
        return this.good.goodsPatentApplicantDtos
          .map((_) => {
            return _.applicantName;
          })
          .join(' ');
      }
    },
  },
};
